<template>
  <div>
    <div class="is-full-width is-flex is-align-items-center is-justify-content-center mb-5">
      <span class="icon is-size-1 p-3">
        <span class="cls cls-tools-wrench-screwdriver" />
      </span>
      <span class="is-size-1 has-text-weight-bold p-3">
        {{ $t('ui.tools') }}
      </span>
    </div>
    <div class="is-flex is-justify-content-center is-flex-wrap-wrap tool-box">
      <div
        v-for="tool in viewableToolPanelItems"
        class="p-3"
        :key="tool.key"
        @click="openTool(tool.component)"
      >
        <div
          :data-e2e="AdminCypressAttribute.toolItemFn(tool.key)"
          class="tool-box-inner p-3 card has-border-light has-border-radius is-radius-large has-shadow is-flex is-flex-direction-column is-align-items-center is-justify-content-center"
        >
          <div class="has-text-weight-semibold has-text-centered">{{ tool.title }}</div>
          <div class="has-text-centered">{{ tool.subtitle }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ToolsPanelItems } from '@/modules/admin/constants/ToolsPanelItems';
import { FormFlowMixin } from '@/modules/core/form/mixins/FormFlowMixin';
import { ComponentForm } from '@/modules/admin/models/ComponentForm';
import { FormComputedValueMixin } from '@/modules/core/form/mixins/FormComputedValueMixin';
import ToolItemModal from '@/modules/admin/components/resource/ToolItemModal.vue';
import { AdminCypressAttribute } from '@/modules/admin/constants/AdminCypressAttribute';
import { HasPermissionMixin } from '@/modules/core/app/mixins/HasPermissionMixin';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ToolsModal',
  mixins: [FormFlowMixin, FormComputedValueMixin, HasPermissionMixin],
  static: {
    ToolsPanelItems,
    AdminCypressAttribute
  },
  computed: {
    viewableToolPanelItems() {
      return ToolsPanelItems.filter((item) => item.isVisible?.(this.permission) ?? true);
    }
  },
  methods: {
    openTool(component) {
      this.computedValue = ComponentForm.mapModel({ component });

      this.flow(ToolItemModal);
    }
  }
};
</script>

<style scoped>
div.tool-box {
  width: var(--ce-700px);
  margin: auto;
}

div.tool-box-inner {
  cursor: pointer;
  height: var(--ce-192px);
  width: var(--ce-192px);
}
</style>
